import { render, staticRenderFns } from "./PlusButton2.vue?vue&type=template&id=8d06cd84&"
import script from "./PlusButton2.vue?vue&type=script&lang=js&"
export * from "./PlusButton2.vue?vue&type=script&lang=js&"
import style0 from "./PlusButton2.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports